@if (auditInfo(); as audit) {
  <p-divider></p-divider>
  <div class="flex justify-end mb-4 mt-2" data-testid="audit-info">
    <div class="text-sm">
      {{ 'auditInfo.lastUpdatedInformation' | transloco }}
      {{ audit.lastUpdatedAt | date: 'dd.MMM.yyyy, HH:mm' }} ({{ audit.lastUpdatedBy }})
    </div>
  </div>
}
